module.exports = ".menus{\r\n   \r\n    color: rgb(0, 0, 0);\r\n   \r\n}\r\n\r\nul#user-dopdown{\r\n    overflow: initial;\r\n    position: absolute;\r\n    right: 10px;\r\n}\r\n\r\nul#user-dopdown .dropdown-menu{\r\n    left: -145px !important;\r\n    top: 45px;\r\n}\r\n\r\nul#user-dopdown a{\r\n    line-height: 20px;\r\n    padding:10px;\r\n}\r\n\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/common/level1menu/level1menu.component.css
// module id = ./src/app/common/level1menu/level1menu.component.css
// module chunks = main